import {} from './animations.js';
const navigationHeight = document.querySelector('header.wp-block-template-part').offsetHeight;
document.documentElement.style.setProperty('--scroll-padding', navigationHeight - 1 + 'px');